import React from "react";
import { useParams } from "react-router-dom";
import SubCatItem from "./components/SubCategorySidebar/SubcatItem";
import Titlebar from "./components/titleBar/Titlebar";
import { useEffect, useState, useRef } from "react";
import logo from "../../img/LOGO.webp";
import useHttp from "../../Request/use-http";
import InfiniteScroll from "react-infinite-scroll-component";
import ProductCard from "./components/ProductList/ProductCard";
import LoadingSpinner from "../../Others/LoadingSpinner";
import AddedToCartBtmSheet from "../../User/Home/Components/Homepage/UI-item,viewAll,BtmSheet/AddedToCartBtmSheet";
import { categories } from "../../Config/MainCategory";
import RuppeOne from "../RuppeeOne/RuppeOne";
const url = process.env.React_App_Api_url;

// -------------------PLP FX----------------------
const PLP = () => {
  const params = useParams();
  const firstRenderRef = useRef(true);
  const [sortedCategories, setSortedCategories] = useState(categories);
  const [InfinteProductList, setInfiniteProductList] = useState([]);
  const [subCatIndex, setSubCatIndex] = useState({
    index: 0,
    mainCat: params.category,
  });
  let debounce = useRef(false);
  // -------------------Hook for apicall----------------------

  const transformTasks = (data) => {
    // console.log(data);
    let sortedproducts = [];
    const subcat = data[Object.keys(data)[0]].subCat.map(
      (el) => el?.subCatName
    );
    const products = data[Object.keys(data)[0]].products;
    subcat.forEach((cat) => {
      let arr = [];

      products.forEach((product) => {
        if (cat === product.subCat) {
          arr.push(product);
        }
      });
      if (arr.length % 2 !== 0) {
        products.push(arr[0]);
        arr = [];
      }
    });
    subcat.forEach((cat) => {
      products.forEach((product) => {
        if (cat === product.subCat) {
          sortedproducts.push(product);
        }
      });
    });
    // console.log(sortedproducts);
    data[Object.keys(data)[0]].products = sortedproducts;

    setInfiniteProductList((PS) => [...new Set([...PS, data])]);
  };

  const { isLoading, error, sendRequest: fetchTasks } = useHttp(transformTasks);

  // -------------------API CALL FX----------------------
  const getProductByCategory = (pickIndex = 0) => {
    if (InfinteProductList.length === categories.length) {
      return;
    }
    fetchTasks({
      url: `${url}/plp/${sortedCategories[pickIndex]}`,
    });
  };

  // -------------------Sorting the categories----------
  // -------------------useEffects----------------------
  useEffect(() => {
    setInfiniteProductList([]); //erase the pervious list
    setSubCatIndex({ index: 0, mainCat: params.category }); //reseting the subcat index
    //sorting the categories
    let categoryOnTopIndex = sortedCategories.findIndex(
      (cat) => cat === params.category
    );

    if (categoryOnTopIndex > -1) {
      setSortedCategories((prevArray) =>
        prevArray
          .slice(categoryOnTopIndex, prevArray.length)
          .concat(prevArray.slice(0, categoryOnTopIndex))
      );
    }
  }, [params.category]);

  useEffect(() => {
    //in first render the categories are sorted
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }
    if (!firstRenderRef.current) {
      getProductByCategory();
    }
  }, [sortedCategories]);

  //updating the subcats-----------------------------------------------
  const changeSubCat = () => {
    const views = [];
    //get the dom position of each mainCat id/ each array element
    InfinteProductList.forEach((mainCat) => {
      const view = document
        .getElementById(Object.keys(mainCat)[0])
        .getBoundingClientRect()?.top;

      views.push({ VIEW: 0 - view, ELEMENT: Object.keys(mainCat)[0] });
    });

    //the smallest positive value in array of views is the element in viewport currently
    const closest = views.reduce((first, second) => {
      if (second.VIEW < 0) {
        return first;
      }
      return first.VIEW < second.VIEW ? first : second;
    });
    //find the subcategories of the main category in viewport
    const findIndex = InfinteProductList.findIndex(
      (element) => Object.keys(element)[0] === closest.ELEMENT
    );
    if (subCatIndex === findIndex) {
      return;
    }
    // console.log(findIndex, closest.ELEMENT);
    //update the subcat
    setSubCatIndex({ index: findIndex, mainCat: closest.ELEMENT });
  };

  // -------------------JSX return----------------------
  return (
    <>
      <Titlebar title={subCatIndex.mainCat} />
      <div className="plp-pg">
        {/* --------------------SubCategory---------------------- */}
        {InfinteProductList.length > 0 ? (
          <>
            <div className="subcategory">
              <SubCatItem
                subCatObj={
                  InfinteProductList[subCatIndex.index][
                    Object.keys(InfinteProductList[subCatIndex.index])[0]
                  ]?.subCat
                }
                subCat={InfinteProductList[subCatIndex.index][
                  Object.keys(InfinteProductList[subCatIndex.index])[0]
                ]?.subCat.map((e) => e.subCatName)}
              />
            </div>
          </>
        ) : null}

        {/* --------------------Product List---------------------- */}
        {InfinteProductList.length > 0 && (
          <InfiniteScroll
            dataLength={InfinteProductList.length}
            hasMore={InfinteProductList.length < categories.length}
            endMessage={<ListEnded />}
            next={() => getProductByCategory(InfinteProductList.length)}
            inverse={false}
            loader={<LoadingSpinner />}
            onScroll={() => {
              if (debounce.current) {
                clearTimeout(debounce.current);
              }
              debounce.current = setTimeout(() => {
                changeSubCat();
              }, 200);
            }}
          >
            {InfinteProductList?.map((mainCat) => (
              <ProductCard
                key={Object.keys(mainCat)[0] + Math.random()}
                products={mainCat[Object.keys(mainCat)[0]]?.products}
                subCat={mainCat[Object.keys(mainCat)[0]]?.subCat.map(
                  (el) => el.subCatName
                )}
              />
            ))}
          </InfiniteScroll>
        )}

        {/*  viewcart */}
        <AddedToCartBtmSheet />
      </div>

      {/* //add the bottom widgets here */}
      {/* <div className="homeBottomSheets" id="plpBottomSheets">
        <RuppeOne />
        <AddedToCartBtmSheet />
        <HomePageOrderTracking />
      </div> */}
    </>
  );
};

export default PLP;

const ListEnded = React.memo(() => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        padding: 10,
      }}
    >
      <img src={logo} alt="logo" height="50px" width="50px" loading="lazy" />
    </div>
  );
});
